import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  action: "",
  id: "set-case-diagnosis-form"
}
const _hoisted_2 = { class: "inner-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "close" }, "X", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, null, -1)
const _hoisted_5 = { id: "prostate-diagnosis-fields" }
const _hoisted_6 = { id: "set-case-diagnosis" }
const _hoisted_7 = {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}
const _hoisted_8 = { value: "Benign" }
const _hoisted_9 = { value: "Adenocarcinoma" }
const _hoisted_10 = { value: "Other cancer" }
const _hoisted_11 = { id: "set-case-gleason" }
const _hoisted_12 = {
  value: "0",
  disabled: "",
  selected: "",
  hidden: ""
}
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<option value=\"ASAP\">ASAP</option><option value=\"3+3\">3+3 (1)</option><option value=\"3+4\">3+4 (2)</option><option value=\"4+3\">4+3 (3)</option><option value=\"3+5\">3+5 (4)</option><option value=\"4+4\">4+4 (4)</option><option value=\"5+3\">5+3 (4)</option><option value=\"4+5\">4+5 (5)</option><option value=\"5+4\">5+4 (5)</option><option value=\"5+5\">5+5 (5)</option>", 10)
const _hoisted_23 = { class: "submit" }
const _hoisted_24 = { id: "breast-diagnosis-fields" }
const _hoisted_25 = { id: "set-breast-case-diagnosis" }
const _hoisted_26 = {
  value: "",
  disabled: "",
  selected: "",
  hidden: ""
}
const _hoisted_27 = { value: "Benign" }
const _hoisted_28 = { value: "Cancer" }
const _hoisted_29 = { id: "set-case-breast-classes" }
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<span><input type=\"checkbox\" value=\"ADH\" id=\"ftf-adh\"><label for>ADH</label></span><span><input type=\"checkbox\" value=\"DCIS\" id=\"ftf-dcis\"><label for>DCIS</label></span><span><input type=\"checkbox\" value=\"Lobular neoplasia\" id=\"ftf-lobular-neoplasia\"><label for>Lobular Neoplasia</label></span><strong>Invasive</strong><span><input type=\"checkbox\" value=\"IDC\" id=\"ftf-idc\"><label for>IDC</label></span><span><input type=\"checkbox\" value=\"ILC\" id=\"ftf-ilc\"><label for>ILC</label></span>", 6)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  value: "OtherInvasive",
  id: "ftf-other-invasive"
}, null, -1)
const _hoisted_37 = { for: "" }
const _hoisted_38 = { id: "ftf-dcis-grade-selection" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  value: "1",
  name: "ftf-dcis-grade",
  id: "ftf-dcis-grade-lg"
}, null, -1)
const _hoisted_40 = { for: "ftf-dcis-grade-lg" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  value: "2",
  name: "ftf-dcis-grade",
  id: "ftf-dcis-grade-ig"
}, null, -1)
const _hoisted_42 = { for: "ftf-dcis-grade-ig" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  value: "3",
  name: "ftf-dcis-grade",
  id: "ftf-dcis-grade-hg"
}, null, -1)
const _hoisted_44 = { for: "ftf-dcis-grade-hg" }
const _hoisted_45 = { class: "submit" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h3", null, [
        _createTextVNode(_toDisplayString(_ctx.t('fast_track.header')) + " ", 1),
        _hoisted_4
      ]),
      _createElementVNode("fieldset", _hoisted_5, [
        _createElementVNode("select", _hoisted_6, [
          _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.t('fast_track.select_diagnosis')), 1),
          _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.t('fast_track.benign')), 1),
          _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.t('fast_track.adenocarcinoma')), 1),
          _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.t('fast_track.other_cancer')), 1)
        ]),
        _createElementVNode("select", _hoisted_11, [
          _createElementVNode("option", _hoisted_12, _toDisplayString(_ctx.t('fast_track.gleason_score')), 1),
          _hoisted_13
        ]),
        _createElementVNode("button", _hoisted_23, _toDisplayString(_ctx.t('fast_track.submit')), 1)
      ]),
      _createElementVNode("fieldset", _hoisted_24, [
        _createElementVNode("select", _hoisted_25, [
          _createElementVNode("option", _hoisted_26, _toDisplayString(_ctx.t('fast_track.select_diagnosis')), 1),
          _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.t('fast_track.benign')), 1),
          _createElementVNode("option", _hoisted_28, _toDisplayString(_ctx.t('fast_track.cancer')), 1)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("section", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('fast_track.non_invasive')), 1),
            _hoisted_30,
            _createElementVNode("span", null, [
              _hoisted_36,
              _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.t('fast_track.other_invasive')), 1)
            ])
          ]),
          _createElementVNode("section", _hoisted_38, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('fast_track.dcis_grade')), 1),
            _createElementVNode("span", null, [
              _hoisted_39,
              _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t('fast_track.low')), 1)
            ]),
            _createElementVNode("span", null, [
              _hoisted_41,
              _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.t('fast_track.intermediate')), 1)
            ]),
            _createElementVNode("span", null, [
              _hoisted_43,
              _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.t('fast_track.high')), 1)
            ])
          ])
        ]),
        _createElementVNode("button", _hoisted_45, _toDisplayString(_ctx.t('fast_track.submit')), 1)
      ])
    ])
  ]))
}